module.exports = __webpack_public_path__ + "images/thumb-e41d7328e69a6efb614f27e767b06398.jpg";